var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import _uniqBy from 'lodash/uniqBy';
import { withTranslation } from "react-i18next";
import { Timeline } from "../timeline";
import styled from "../../styled";
import { FaCheck, FaBan } from "react-icons/fa";
/** Terminal status banner (Order Completed / Order Cancelled / Seated). */
export const StatusBanner = styled("div") `
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	margin: 16px;
	padding: 20px 16px;
	border-radius: 8px;
	background: ${({ tone }) => (tone === "success" ? "#ecfdf3" : "#fee4e2")};
	color: ${({ tone }) => (tone === "success" ? "#067647" : "#912018")};
	font-size: 18px;
	font-weight: 700;
	line-height: 1.2;
`;
const StatusBannerIcon = styled("div") `
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	font-size: 18px;
	background: ${({ tone }) => (tone === "success" ? "#d1fadf" : "transparent")};
	${({ tone }) => (tone === "error" ? "font-size: 36px; width: 36px; height: 36px;" : "")}
`;
let OrderTimelineClass = class OrderTimelineClass extends React.Component {
    render() {
        const { t, status, isDelivery, isBooking } = this.props;
        if (status === "cancelled" ||
            status === "complete" ||
            (isBooking && status === "seated")) {
            const isSeated = isBooking && status === "seated";
            const tone = status === "cancelled" ? "error" : "success";
            const label = isSeated
                ? t("booking.status.seated", { defaultValue: "Seated" })
                : status === "complete"
                    ? t("order.status_banner.complete", { defaultValue: "Order Completed" })
                    : t("order.status_banner.cancelled", { defaultValue: "Order Cancelled" });
            return (React.createElement(StatusBanner, { tone: tone, className: "order-status-banner" },
                React.createElement(StatusBannerIcon, { tone: tone }, tone === "success" ? React.createElement(FaCheck, null) : React.createElement(FaBan, null)),
                React.createElement("span", null, label)));
        }
        let stages = [];
        let defaultStages = [
            { id: "confirmed", label: t("order.status.confirmed") },
            { id: "ready", label: t("order.status.ready") },
            { id: "on_route", label: t("order.status.on_route") },
        ];
        if (status === "unconfirmed" || status === "awaiting_payment") {
            let beforeConfirmed = { id: "unconfirmed", label: t("order.status.unconfirmed") };
            if (status === "awaiting_payment")
                beforeConfirmed = { id: "awaiting_payment", label: t("order.status.awaiting_payment") };
            stages = [beforeConfirmed, ...defaultStages];
        }
        else {
            stages = defaultStages;
        }
        stages = _uniqBy(stages, 'id');
        if (isBooking) {
            stages = [
                { id: "unconfirmed", label: t("order.status.unconfirmed") },
                { id: "confirmed", label: t("order.status.confirmed") },
            ];
        }
        else if (!isDelivery) {
            stages.splice(stages.length - 1, 1);
        }
        return (React.createElement(Timeline, { stages: stages, current: status }));
    }
};
OrderTimelineClass = __decorate([
    observer
], OrderTimelineClass);
export const OrderTimeline = withTranslation()(OrderTimelineClass);
//# sourceMappingURL=timeline.js.map